export default __webpack_public_path__ + "static/media/star_filled.81114b83.svg";